import { useEffect } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";
import { useContext } from "react";

export const useBlockNavigation = (when, message) => {
  const navigator = useContext(NavigationContext).navigator;

  useEffect(() => {
    if (!when) return;

    const push = navigator.push;

    navigator.push = (...args) => {
      const confirmLeave = window.confirm(message);
      if (confirmLeave) {
        navigator.push = push; // restore original
        navigator.push(...args); // proceed
      }
    };

    return () => {
      navigator.push = push; // cleanup on unmount
    };
  }, [when, message, navigator]);
};
